import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const PARK_LAYER_ID = 'parkLayer';

const layerConfig = {
  title: 'Park',
};

function ParkLayer() {
  const dispatch = useDispatch();
  const { parkLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, parkLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (parkLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: PARK_LAYER_ID,
      geoColumn: 'geom',  // Specify the geometry column for polygon data

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: parkLayer.visible,
      opacity: parkLayer.opacity,
      getFillColor: [0, 128, 0],
      pointRadiusMinPixels: 3.5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: PARK_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Park',
              includeColumns: [
                'Park_Name',
                'Park_City',
              ],
            }),
          };
        }
      },
    });
  }
}

export default ParkLayer;
